import { Table } from "react-bootstrap"

const tableHead = () => (
  <thead>
    <tr>
      <th>Field</th>
      <th>Old Value</th>
      <th>Updated Value</th>
    </tr>
  </thead>
)

export const tableComponent = (body) => (
  <Table striped>
    {tableHead()}
    <tbody>
      {body}
    </tbody>
  </Table>
)